









import Vue, { PropType } from "vue";

export interface RedirectProps {
  url: string;
  limitTime: number;
}

export interface RedirectData {
  countTime: number;
  isComplete: boolean;
}

export default Vue.extend({
  name: "vc-redirect",
  data(): RedirectData {
    return {
      countTime: 0,
      isComplete: false
    };
  },
  props: {
    url: {
      type: String as PropType<RedirectProps["url"]>,
      default: ""
    },
    limitTime: {
      type: Number as PropType<RedirectProps["limitTime"]>,
      default: ""
    }
  },
  mounted: function() {
    const id = setInterval(() => {
      if (this.countTime >= this.limitTime) {
        this.isComplete = true;
        clearInterval(id);
        window.location.href = this.url;
      }
      this.countTime++;
    }, 1000);
  }
});
